import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-notice-btn-detail",
  "use": "icon-notice-btn-detail-usage",
  "viewBox": "0 0 53 51",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53 51\" fill=\"none\" id=\"icon-notice-btn-detail\">\n  <circle cx=\"26.5\" cy=\"25.5\" r=\"23.5\" stroke=\"currentColor\" stroke-width=\"2\" />\n  <path d=\"M30 16H20c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h13c1.1 0 2-.9 2-2V21l-5-5zm0 14H21v-2h9v2zm0-4H21v-2h9v2zm-4-6V17.5L29.5 22H26z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/notice/notice-btn-detail.svg
// module id = Oe9l
// module chunks = 24